namespace TabAurous.Retail {

    @Serenity.Decorators.registerClass()
    @Serenity.Decorators.maximizable()
    export class TimeWiseDialog extends Serenity.TemplatedDialog<any> {
        public isclosed: boolean;
        getTemplate() {
            return `<div id="GridDiv" style = "height: 360px;margin:0px 15px 0px"></div>
                <div id = "GridDiv1" style = "height: 360px;margin:0px 15px 0px"></div>

                    <script type = "text/javascript" >
                        jQuery(function () {
                            new TabAurous.Retail.POSSalesReportGrid($('#GridDiv'), {}).init();


                        });
            jQuery(function () {
                new TabAurous.Retail.POSSalesDayWiseGrid($('#GridDiv1'), {}).init();


            });
            </script>`
        }
        static selectedboms = [];
        public items = [];
        checkGrid: POSSalesReportGrid;
        checkGrid2: POSSalesDayWiseGrid;
        constructor() {
            super();
            //var gridType = POSSalesReportGrid;
            //this.checkGrid = new gridType(this.byId("RowSelectionCheckGrid"));
            //var gridType2 = POSSalesDayWiseGrid;
            //this.checkGrid2 = new gridType2(this.byId("RowSelectionCheckGrid1"));
            this.dialogTitle = "Report : Time Wise Sales";
            //this.checkGrid.element.height(650);
        }

        onSuccess = () => { this.checkGrid.refresh(); return 0; }

        getDialogOptions() {
            let opt = super.getDialogOptions();

            opt.width = 1500;
            return opt
        }
        protected onDialogOpen() {
            jQuery(".ui-dialog-titlebar-maximize").click();
            super.onDialogOpen();

        }

    }
}